export default __webpack_public_path__ + "static/media/Mensaje_impacto_mundo4.d566f173.png";